import React from "react";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import ScrollToTop from "./component/scrollToTop";
import { Route, Routes } from "react-router-dom"; 
import Automotive from "./pages/subPages/Automotive"; 
import FoodBeverage from "./pages/subPages/FoodBeverage";
import Produce from "./pages/subPages/Produce";
import RenewableEnergy from "./pages/subPages/RenewableEnergy";
import Retail from "./pages/subPages/Retail";
import Manufacturing from "./pages/subPages/Manufacturing";
import BuildingMaterials from "./pages/subPages/BuildingMaterials";
import OilGasEnergy from "./pages/subPages/OilGasEnergy";
import HealthcarePharma from "./pages/subPages/HealthPharma";
import GovernmentDefense from "./pages/subPages/GovernmentDefense";
import Drayage from "./pages/subPages/Drayage";
import Warehousing from "./pages/subPages/Warehousing";
import OverTheRoad from "./pages/subPages/OverTheRoad";
import Intermodal from "./pages/subPages/Intermodal";
import Flatbed from "./pages/subPages/Flatbed";
import Reefer from "./pages/subPages/Reefer";
import LTL from "./pages/subPages/LTL";
import CrossBorder from "./pages/subPages/CrossBorder";
import LicensingInfo from "./pages/subPages/LicenseInfo";
import PrivacyPolicy from "./pages/subPages/PrivacyPolicy";
import ComingSoon from "./pages/subPages/ComingSoon";

const AppRouter = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/automotive" element={<Automotive />} />
        <Route path="/food-beverage" element={<FoodBeverage />} />
        <Route path="/produce" element={<Produce />} />
        <Route path="/renewable-energy" element={<RenewableEnergy />} />
        <Route path="/retail" element={<Retail />} />
        <Route path="/manufacturing" element={<Manufacturing />} />
        <Route path="/building-materials" element={<BuildingMaterials />} />
        <Route path="/oil-gas-energy" element={<OilGasEnergy />} />
        <Route path="/healthcare-pharma" element={<HealthcarePharma />} />
        <Route path="/government-defense" element={<GovernmentDefense />} />
        <Route path="/drayage" element={<Drayage />} />
        <Route path="/warehousing" element={<Warehousing />} />
        <Route path="/over-the-road" element={<OverTheRoad />} />
        <Route path="/intermodal" element={<Intermodal />} />
        <Route path="/flatbed" element={<Flatbed />} />
        <Route path="/reefer" element={<Reefer />} />
        <Route path="/ltl" element={<LTL />} />
        <Route path="/cross-border" element={<CrossBorder />} />
        <Route path="/licensing-info" element={<LicensingInfo />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/coming-soon" element={<ComingSoon />} />
      

      </Routes>
    </>
  );
};

export default AppRouter;
